<template lang="html">
  <div class="content">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.content {
}
</style>



// WEBPACK FOOTER //
// src/parts/layout/content.vue